import { createAction } from "@reduxjs/toolkit";

export const wsconnect = createAction('ws/connect');
export const wsdisconnect = createAction('ws/disconnect');
export const wssend = createAction('ws/send');